const SEARCH_PATH = "otto.de/suche/";
const PDP_PATH = "otto.de/p/";
const SELLER_FILTER_KEY = "verkaeufer";
const SESSION_STORAGE_KEY = "reco_filters";

export const getSearchFilter = (referrerUrl) => {
    if (isSearchUrl(referrerUrl)) {
        return getSearchFilterFromSearchUrl(referrerUrl, SELLER_FILTER_KEY);
    } else if (isPDPUrl(referrerUrl)) {
        return getSearchFilterFromStorage(referrerUrl);
    } else {
        clearSearchFilterStorage();
        return null;
    }
};

export const getAllSellerFilters = () => {
    const searchFilter = getSearchFilterFromStorage();
    return searchFilter !== null
        ? searchFilter
              .split("&")
              .filter((filter) => filter.startsWith(`${SELLER_FILTER_KEY}=`))
              .map((filter) => filter.split("=")[1].split(","))
              .flat()
        : [];
};

export const hasSellerFilters = () => {
    const searchFilter = getSearchFilterFromStorage();
    return searchFilter !== null && searchFilter.includes(SELLER_FILTER_KEY);
};

export const removeAllSellerFilter = () => {
    const searchFilter = getSearchFilterFromStorage();
    const newSearchFilter = searchFilter
        ? searchFilter
              .split("&")
              .filter((filter) => !filter.startsWith(`${SELLER_FILTER_KEY}=`))
              .join("&")
        : null;
    saveSearchFilter(newSearchFilter);
};

export const removeSellerFilter = (seller) => {
    const searchFilter = getSearchFilterFromStorage();
    const newSearchFilter = searchFilter
        .split("&")
        .map((filter) => {
            if (filter.startsWith(`${SELLER_FILTER_KEY}=`)) {
                const sellers = filter.split("=")[1].split(",");
                return sellers.length === 1 && sellers[0] === seller
                    ? ""
                    : `${SELLER_FILTER_KEY}=${sellers.filter((s) => s !== seller).join(",")}`;
            }
            return filter;
        })
        .filter((filter) => filter !== "")
        .join("&");
    saveSearchFilter(newSearchFilter);
    return newSearchFilter;
};

const getSearchFilterFromSearchUrl = (referrerUrl, filterKey) => {
    try {
        const url = new URL(referrerUrl);
        const queryParams = new URLSearchParams(url.search);
        const filterValue = queryParams.get(filterKey);

        if (!filterValue) {
            clearSearchFilterStorage();
            return null;
        }

        const searchFilter = `${filterKey}=${filterValue}`;
        saveSearchFilter(searchFilter);
        return searchFilter;
    } catch (err) {
        return null;
    }
};

const getSearchFilterFromStorage = () => {
    return sessionStorage.getItem(SESSION_STORAGE_KEY);
};

const isPDPUrl = (referrerUrl) => {
    if (!referrerUrl) return false;
    return new URL(referrerUrl).toString().includes(PDP_PATH);
};

const isSearchUrl = (referrerUrl) => {
    if (!referrerUrl) return false;
    return new URL(referrerUrl).toString().includes(SEARCH_PATH);
};

const saveSearchFilter = (filterValue) => {
    if (filterValue === null || filterValue === "") {
        clearSearchFilterStorage();
        return;
    }
    sessionStorage.setItem(SESSION_STORAGE_KEY, `${filterValue}`);
};

const clearSearchFilterStorage = () => {
    sessionStorage.removeItem(SESSION_STORAGE_KEY);
};
